import { useState } from "react";
import { usePassAuth } from "../../context/PasswordAuthContext";
import { useLocation, useNavigate } from "react-router-dom";

// const ResetPassword = () => {
//   const { resetPassword, loading } = usePassAuth();
//   const location = useLocation();
//   const navigate = useNavigate();

//   const params = new URLSearchParams(location.search);

//   const email = params.get("email");
//   const token = params.get("token");
//   const account = params.get("account");

//   const [password, setPassword] = useState("");
//   const [confirmPassword, setConfirmPassword] = useState("");
//   const [message, setMessage] = useState("");

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (password !== confirmPassword) {
//       setMessage("Passwords do not match");
//       return;
//     }

//     try {
//       //   const res = await resetPassword({
//       //     email,
//       //     token,
//       //     password,
//       //     account,
//       //   });
//       const payload = {
//         email,
//         password,
//         account,
//       };

//       if (token) {
//         payload.token = token;
//       }

//       const res = await resetPassword(payload);
//       console.log("res from reset", res);
//       setMessage(res.message);

//       setTimeout(() => {
//         navigate("/loginpage");
//       }, 2000);
//     } catch (err) {
//       setMessage(err?.response?.data?.message || "Password reset failed");
//     }
//   };

//   return (
//     // <div>
//     //   <h2>Reset Password</h2>

//     //   <form onSubmit={handleSubmit}>
//     //     <input
//     //       type="password"
//     //       placeholder="New Password"
//     //       value={password}
//     //       onChange={(e) => setPassword(e.target.value)}
//     //     />

//     //     <input
//     //       type="password"
//     //       placeholder="Confirm Password"
//     //       value={confirmPassword}
//     //       onChange={(e) => setConfirmPassword(e.target.value)}
//     //     />

//     //     <button type="submit">Reset Password</button>
//     //   </form>

//     //   {message && <p>{message}</p>}
//     // </div>
//     <div className="reg-page-wrapper">
//       <h2 className="reg-page-title">Reset Password</h2>

//       <form className="reg-form" onSubmit={handleSubmit}>
//         {/* NEW PASSWORD */}
//         <input
//           className="reg-input"
//           type="password"
//           placeholder="New Password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//         />

//         {/* CONFIRM PASSWORD */}
//         <input
//           className="reg-input"
//           type="password"
//           placeholder="Confirm Password"
//           value={confirmPassword}
//           onChange={(e) => setConfirmPassword(e.target.value)}
//         />

//         {message && (
//           <p className="reg-error" style={{ textAlign: "center" }}>
//             {message}
//           </p>
//         )}

//         <button className="reg-submit-btn" disabled={loading}>
//           {loading ? "Updating..." : "Reset Password"}
//         </button>
//       </form>

//       <p style={{ textAlign: "center", marginTop: "16px" }}>
//         Back to{" "}
//         <span
//           style={{ fontWeight: "500", cursor: "pointer", color: "#007bff" }}
//           onClick={() => navigate("/login")}
//         >
//           Login
//         </span>
//       </p>
//     </div>
//   );
// };
const ResetPassword = () => {
  const { resetPassword, loading } = usePassAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const params = new URLSearchParams(location.search);

  const email = params.get("email");
  const token = params.get("token");
  const account = params.get("account");

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState("");
  const [isError, setIsError] = useState(false); // ✅ NEW

  const handleSubmit = async (e) => {
    e.preventDefault();

    /* ✅ VALIDATIONS */
    if (!password || !confirmPassword) {
      setIsError(true);
      setMessage("All fields are required");
      return;
    }

    if (password.length < 6) {
      setIsError(true);
      setMessage("Password must be at least 6 characters");
      return;
    }

    if (password !== confirmPassword) {
      setIsError(true);
      setMessage("Passwords do not match");
      return;
    }

    try {
      const payload = {
        email,
        password,
        account,
      };

      if (token) payload.token = token;

      const res = await resetPassword(payload);

      setIsError(false); // ✅ SUCCESS
      setMessage(res.message || "Password updated successfully");

      /* ✅ AUTO REDIRECT */
      setTimeout(() => {
        navigate("/loginpage"); // 🔥 FIXED ROUTE
      }, 1500);
    } catch (err) {
      setIsError(true);
      setMessage(err?.response?.data?.message || "Password reset failed");
    }
  };

  return (
    <div className="reg-page-wrapper">
      <h2 className="reg-page-title">Reset Password</h2>

      <form className="reg-form" onSubmit={handleSubmit}>
        {/* NEW PASSWORD */}
        <input
          className="reg-input"
          type="password"
          placeholder="New Password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            setMessage(""); // ✅ CLEAR MESSAGE
          }}
        />

        {/* CONFIRM PASSWORD */}
        <input
          className="reg-input"
          type="password"
          placeholder="Confirm Password"
          value={confirmPassword}
          onChange={(e) => {
            setConfirmPassword(e.target.value);
            setMessage(""); // ✅ CLEAR MESSAGE
          }}
        />

        {/* ✅ MESSAGE */}
        {message && (
          <p
            className={isError ? "reg-error" : "reg-success"}
            style={{ textAlign: "center" }}
          >
            {message}
          </p>
        )}

        <button className="reg-submit-btn" disabled={loading}>
          {loading ? "Updating..." : "Reset Password"}
        </button>
      </form>

      {/* ✅ FIXED ROUTE */}
      <p style={{ textAlign: "center", marginTop: "16px" }}>
        Back to{" "}
        <span
          style={{ fontWeight: "500", cursor: "pointer", color: "#007bff" }}
          onClick={() => navigate("/loginpage")}
        >
          Login
        </span>
      </p>
    </div>
  );
};
export default ResetPassword;
